export const BOTTOM_HEIGHT = 10

export const QA_NAME_DROPDOWN_CONTEXT = 'Dropdown'
